import firebase from 'src/firebase/firebase'
import { labels } from 'src/labels/main_labels'
import { getDefaultLang } from 'src/utils/defaultLang'

const language = getDefaultLang()

export const recoverAccountPassword = async (email: string): Promise<any> => {
  try {
    return await firebase.auth.sendPasswordResetEmail(email)
  } catch (error) {
    throw new Error(labels[language].errorWhenSendingEmail2)
  }
}

export const getUserData = async (id: string): Promise<any> => {
  return firebase.db
    .collection('users')
    .doc(id)
    .get()
    .then((response) => {
      const data = response.data()
      return data
    })
    .catch(() => {
      throw new Error(labels[language].errorUserData)
    })
}

export const createUser = async (data: Record<string, any>): Promise<any> => {
  const createUserCloud = firebase.functions.httpsCallable('createUser')

  try {
    return createUserCloud(data.credentials).then(async (newUserRef) => {
      await firebase.db
        .collection('users')
        .doc(newUserRef.data.uid)
        .set({
          id: newUserRef.data.uid,
          storeId: data.credentials.store || null,
          companyId: data.credentials.companyId || null,
          birthDate: data.credentials.birthDate || null,
          gender: data.credentials.gender || null,
          sector: data.credentials.sector || null,
          position: data.credentials.position || null,
          workingSince: data.credentials.workingSince || null,
          email: data.credentials.email,
          name: data.profileData.name,
          lastname: data.profileData.lastname,
          lastname2: data.profileData.lastname2,
          createdAt: new Date(),
          comunPatology: data.profileData.comunPatology || { id: false, name: 'No' },
          comunPatologyBookings: 0,
          createdBy: data.profileData.creatorUid,
          role: data.profileData.role
        })
    })
  } catch (error) {
    throw new Error(labels[language].errorWhenCreatingUser)
  }
}

export const updateUser = async (userData: Record<string, any>): Promise<any> => {
  try {
    return firebase.db.collection('users').doc(userData.uid).update(userData)
  } catch (error) {
    throw new Error(labels[language].errorUserUpdateData)
  }
}
